import { AfterViewInit, Component, Input, Output, ElementRef, EventEmitter, OnInit, NgModule, Renderer, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import { Subject } from 'rxjs/Subject';

import { DebounceinputRoutingModule } from './debounceinput.routing.module';

@Component({
  selector: 'debounceinput',
  template: `
  <input #input class="form-control grid-search-input" type="text" [(ngModel)]="inputValue" [placeholder]="placeholder">
  <a *ngIf="inputValue" class="waves-effect waves-light" style="padding-right: 15px;" (click)="clear()">
      <i class="fa fa-remove fa-lg"></i>
  </a>`,
  styles: [`
  input[type="text"]::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    color: #007bff;
  }
  input[type="text"]::-moz-placeholder { /* Firefox 19+ */
    color: #007bff;
  }
  input[type="text"]:-ms-input-placeholder { /* IE 10+ */
    color: #007bff;
  }
  input[type="text"]:-moz-placeholder { /* Firefox 18- */
    color: #007bff;
  }
  .grid-search-input {
    width: calc(100% - 40px) !important;
  }`],
  encapsulation: ViewEncapsulation.None
})

export class DebounceinputComponent {
  @Input() placeholder: string;
  @Input() delay: number = 800;
  @Output() updated: EventEmitter<string> = new EventEmitter<string>();

  @Input() public inputValue: string;
  @ViewChild('input') input: ElementRef;
  public value: Subject<string>;

  ngOnInit() {
  }

  ngAfterViewInit() {
    const eventStream = Observable.fromEvent(this.input.nativeElement, 'keyup')
      .map(() => this.inputValue)
      .debounceTime(this.delay);
    eventStream.subscribe((input:any) => {
      this.value.next(input);
    });
    this.value = new Subject();
    this.value.next(this.inputValue);
    this.value.subscribe((newValue) => {
      this.updated.emit(newValue);
    });
  }

  clear() {
    this.inputValue = '';
    this.value.next(this.inputValue);
  }
}
